
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentUserPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CurrentUserPermissions"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buy_asset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buy_collection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buy_drop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deposit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sell_asset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sell_collection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sell_with_dibbs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"withdraw"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":172}};
    doc.loc.source = {"body":"fragment CurrentUserPermissions on CurrentUserPermissions {\n  buy_asset\n  buy_collection\n  buy_drop\n  deposit\n  sell_asset\n  sell_collection\n  sell_with_dibbs\n  withdraw\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
